'use client'
import type { ReactNode, ButtonHTMLAttributes, InputHTMLAttributes,
  SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Switch({
  label,
  checked,
  onChange,
}: {
  label?: ReactNode
  checked: boolean
  onChange: (next: boolean) => void
}) {
  return (
    <label className="inline-flex cursor-pointer items-center gap-2.5 text-[15px] text-ink-2 select-none">
      <span
        className={cx(
          'relative inline-flex h-5 w-9 shrink-0 rounded-full border-2 transition-colors duration-150',
          checked
            ? 'border-accent-fill bg-accent-fill'
            : 'border-line-strong bg-sunken',
        )}
      >
        <span
          className={cx(
            'absolute top-1/2 h-3.5 w-3.5 -translate-y-1/2 rounded-full bg-surface shadow-[var(--shadow-xs)] transition-all duration-150',
            checked ? 'left-[calc(100%-1rem)]' : 'left-0.5',
          )}
        />
        <input type="checkbox" className="sr-only" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      </span>
      {label}
    </label>
  )
}
